import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { SendFeedbackIcon } from "../../assets";

const UserFeedback = ({ isEditing, handleChangeEditor }) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const maxTextAreaHeight = 300;

  const adjustTextAreaHeight = () => {
    const textArea = document.getElementById("textArea");

    // Reset the height to calculate the scrollHeight correctly
    textArea.style.height = "auto";

    // Check the required height
    const newHeight = Math.min(textArea.scrollHeight, maxTextAreaHeight);

    // Set the height and overflow
    textArea.style.height = `${newHeight}px`;
    textArea.style.overflowY =
      textArea.scrollHeight > maxTextAreaHeight ? "scroll" : "hidden";
  };

  useEffect(() => {
    if (isEditing) {
      adjustTextAreaHeight();
      const textArea = document.getElementById("textArea");
      textArea.focus();
    }
    // eslint-disable-next-line
  }, [watch("userFeedback"), isEditing]);

  return (
    <div className="grey-bg-wrapper">
      <div className="d-flex justify-content-between align-items-center">
        <div className="heading">
          {isEditing ? "User Feedback" : "Feedback"}
        </div>
        {!isEditing && (
          <div
            className="d-flex align-items-center gap-2 edit-info-button-container"
            onClick={() => {
              handleChangeEditor(true);
            }}
          >
            <img src={SendFeedbackIcon} alt="" />
            <div className="section-edit-text">Send Feedback</div>
          </div>
        )}
      </div>
      {isEditing && (
        <>
          <div className="input-field text-area-field">
            <textarea
              {...register("userFeedback")}
              id="textArea"
              onInput={adjustTextAreaHeight} // Ensure height adjusts on manual input
            />
            {errors.userFeedback && (
              <div className="error mt-2">{errors.userFeedback.message}</div>
            )}
          </div>
          <div className="mt-4 d-flex justify-content-center gap-3">
            <RoundedButton className="px-4 px-md-5 py-1" type="submit">
              Submit
            </RoundedButton>
            <RoundedButton
              className="px-4 px-md-5 py-1"
              variant="outlined"
              onClick={() => {
                handleChangeEditor(false);
              }}
            >
              Cancel
            </RoundedButton>
          </div>
        </>
      )}
    </div>
  );
};

export default UserFeedback;
